import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { FormattedMessage } from 'react-intl';
import Modal from 'react-modal';
import classNames from 'classnames';
import 'react-dual-listbox/lib/react-dual-listbox.css';

import { RootState } from '../../reducers';
import './Start.scss';
import * as actions from '../../actions/index';
import { getParameterByName } from '../../utils/toSearchParams';
import BreadCrumbs from '../../components/BreadCrumbs';
import Aside from '../../components/Aside';
import Card from '../../components/Card';

import { ReactComponent as IconJourney1 } from '../../assets/icons/journey1.svg';
import { ReactComponent as IconJourney2 } from '../../assets/icons/journey2.svg';
import { ReactComponent as IconJourney3 } from '../../assets/icons/journey3.svg';
import bsStyles from '../../styles/bs.module.scss';
import { useNavigate } from 'react-router';

interface Props {
  history: any;
  isLoading: boolean;
  location: any;
  actions: any;
  intl: any;
}

const Start = (props: Props) => {
  const navigate = useNavigate();

  useEffect(() => {
    props.actions.clearData('start');
  }, []);

  const renderModalContent = (modalContent) => {
    if (modalContent === 'faq') {
      return <Aside modal step={0} />;
    } else {
      return null;
    }
  };

  const renderStart = () => {
    const modalContent = getParameterByName('modalContent', props.location.search);

    return (
      <div className='pageContainer start'>
        {modalContent && (
          <Modal
            isOpen={Boolean(modalContent)}
            onRequestClose={() => {
              navigate({ search: '' });
            }}
            shouldCloseOnOverlayClick={true}
            className={'large-modal'}
            closeTimeoutMS={0}
            overlayClassName={'overlay'}
          >
            <div className={classNames('background-light-grey modal', bsStyles.bootstrap)}>
              {modalContent && renderModalContent(modalContent)}
            </div>
          </Modal>
        )}

        <div className='main'>
          <div className='header'>
            <div className='card rounded-0'>
              <h1 className='color-red'>
                <FormattedMessage id='ec.landingPage.welcomeTitle' defaultMessage='APG|SGA easy' />
              </h1>

              <p className='color-red ps-0'>
                <FormattedMessage
                  id='ec.landingPage.welcomeSubTitle'
                  defaultMessage='Planen und buchen Sie online Ihre Aussenwerbung – einfach und effizient.'
                />
              </p>
            </div>

            <p
              className={classNames('my-48', {
                'col-12': window.innerWidth < 769,
              })}
            >
              <FormattedMessage
                id='ec.landingPage.welcomeText'
                defaultMessage='Hier auf APG|SGA easy können Sie einzelne Plakate, ganze Plakat-Netze und/oder digitale Netze planen und buchen. Von der kleinen, punktuellen Kampagne bis zu flächendeckenden Aushängen ist alles möglich. Orte, Zeit und Budgetbetrag bestimmen Sie selbst. Sogar die Realisation Ihrer Sujets können Sie via APG|SGA easy lösen. Bei Fragen beachten Sie bitte die Box «Gut zu wissen» oder rufen Sie uns an.'
              />
            </p>
          </div>

          <h4
            className={classNames('mb-24', {
              'col-12': window.innerWidth < 769,
            })}
          >
            <FormattedMessage
              id='ec.landingPage.chooseYourOption'
              defaultMessage='Wie möchten Sie Ihre Werbeflächen zusammenstellen?'
            />
          </h4>

          <div className='row w-100 m-0 justify-content-start'>
            <div className='col-6'>
              <Card
                to={`journey1/1`}
                icon={<IconJourney1 />}
                title={props.intl.formatMessage({
                  id: 'ec.landingPage.journey1Label',
                  defaultMessage: 'Eine Empfehlung berechnen lassen',
                })}
                text={props.intl.formatMessage({
                  id: 'ec.landingPage.journey1Explanation',
                  defaultMessage: 'Sie bekommen einen Vorschlag mit bestmöglichen Werbeflächen',
                })}
              />
            </div>

            <div className='col-6'>
              <Card
                to={`journey2/1`}
                icon={<IconJourney2 />}
                title={props.intl.formatMessage({
                  id: 'ec.landingPage.journey2Label',
                  defaultMessage: 'Gezielt Werbeflächen auswählen',
                })}
                text={props.intl.formatMessage({
                  id: 'ec.landingPage.journey2Explanation',
                  defaultMessage: 'Sie wählen selber, gezielt Ihre Werbeflächen aus.',
                })}
              />
            </div>

            <div className='col-6'>
              <Card
                to={`journey3/campaigns`}
                icon={<IconJourney3 />}
                title={props.intl.formatMessage({
                  id: 'ec.landingPage.journey3Label',
                  defaultMessage: 'Vergangene Kampagne nochmals buchen',
                })}
                text={props.intl.formatMessage({
                  id: 'ec.landingPage.journey3Explanation',
                  defaultMessage: 'Hier wählen Sie Ihre Plakate und/oder Screens nach eigenen Kriterien aus.',
                })}
              />
            </div>
          </div>
        </div>

        <Aside step={0} />
      </div>
    );
  };

  return (
    <>
      <BreadCrumbs />
      <div className='container-fluid journey1 p-0'>
        <div>{renderStart()}</div>
      </div>
    </>
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    location: state.router.location,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    actions: bindActionCreators(actions as any, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Start);
